declare namespace $ {

	type $mol_view__sub_shm_dashboard_admin_settings_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__keyboard_shm_dashboard_admin_settings_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__hint_shm_dashboard_admin_settings_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_task_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_5 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_task_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_6 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['default_task_limit_commit'] > ): ReturnType< $shm_dashboard_admin_settings['default_task_limit_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_8 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Default_task_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_dashboard_admin_settings_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__hint_shm_dashboard_admin_settings_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_11 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_hourly_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_12 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_hourly_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_13 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['default_hourly_limit_commit'] > ): ReturnType< $shm_dashboard_admin_settings['default_hourly_limit_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Default_hourly_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_dashboard_admin_settings_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__hint_shm_dashboard_admin_settings_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_18 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_regular_daily_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_19 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_regular_daily_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_20 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['default_regular_daily_limit_commit'] > ): ReturnType< $shm_dashboard_admin_settings['default_regular_daily_limit_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_22 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Default_regular_daily_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_dashboard_admin_settings_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_24 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_query_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_25 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_query_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_26 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['default_query_limit_commit'] > ): ReturnType< $shm_dashboard_admin_settings['default_query_limit_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_28 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Default_query_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__keyboard_shm_dashboard_admin_settings_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_30 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_subtask_limit_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_31 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['default_subtask_limit_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_32 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['default_subtask_limit_commit'] > ): ReturnType< $shm_dashboard_admin_settings['default_subtask_limit_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_34 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Default_subtask_limit'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_settings_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_dashboard_admin_settings_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_dashboard_admin_settings_37 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['notifications_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_password__value_shm_dashboard_admin_settings_38 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['telegram_token_draft'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_password__submit_shm_dashboard_admin_settings_39 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['telegram_token_commit'] >
		,
		ReturnType< $mol_password['submit'] >
	>
	type $mol_password__event_shm_dashboard_admin_settings_40 = $mol_type_enforce<
		({ 
			focusout( next?: ReturnType< $shm_dashboard_admin_settings['telegram_token_commit'] > ): ReturnType< $shm_dashboard_admin_settings['telegram_token_commit'] >,
		})  & ReturnType< $mol_password['event'] >
		,
		ReturnType< $mol_password['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_42 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Telegram_token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_43 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['telegram_chat_id_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_44 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['telegram_chat_id_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_45 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['telegram_chat_id_commit'] > ): ReturnType< $shm_dashboard_admin_settings['telegram_chat_id_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_47 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Telegram_chat_id'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_settings_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_password__value_shm_dashboard_admin_settings_49 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['max_token_draft'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_password__submit_shm_dashboard_admin_settings_50 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['max_token_commit'] >
		,
		ReturnType< $mol_password['submit'] >
	>
	type $mol_password__event_shm_dashboard_admin_settings_51 = $mol_type_enforce<
		({ 
			focusout( next?: ReturnType< $shm_dashboard_admin_settings['max_token_commit'] > ): ReturnType< $shm_dashboard_admin_settings['max_token_commit'] >,
		})  & ReturnType< $mol_password['event'] >
		,
		ReturnType< $mol_password['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_53 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Max_token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_dashboard_admin_settings_54 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['max_chat_id_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_dashboard_admin_settings_55 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['max_chat_id_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_dashboard_admin_settings_56 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_dashboard_admin_settings['max_chat_id_commit'] > ): ReturnType< $shm_dashboard_admin_settings['max_chat_id_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_dashboard_admin_settings_57 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_dashboard_admin_settings_58 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_settings['Max_chat_id'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_dashboard_admin_settings_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_settings_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_settings_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_settings extends $mol_view {
		settings_rows( ): readonly(any)[]
		Defaults_title( ): $mol_view
		default_task_limit_draft( next?: string ): string
		default_task_limit_commit( next?: any ): any
		Default_task_limit( ): $mol_string
		Default_task_limit_label( ): $mol_labeler
		default_hourly_limit_draft( next?: string ): string
		default_hourly_limit_commit( next?: any ): any
		Default_hourly_limit( ): $mol_string
		Default_hourly_limit_label( ): $mol_labeler
		default_regular_daily_limit_draft( next?: string ): string
		default_regular_daily_limit_commit( next?: any ): any
		Default_regular_daily_limit( ): $mol_string
		Default_regular_daily_limit_label( ): $mol_labeler
		default_query_limit_draft( next?: string ): string
		default_query_limit_commit( next?: any ): any
		Default_query_limit( ): $mol_string
		Default_query_limit_label( ): $mol_labeler
		default_subtask_limit_draft( next?: string ): string
		default_subtask_limit_commit( next?: any ): any
		Default_subtask_limit( ): $mol_string
		Default_subtask_limit_label( ): $mol_labeler
		Notifications_title( ): $mol_view
		notifications_enabled( next?: boolean ): boolean
		Notifications_enabled( ): $mol_check_box
		telegram_token_draft( next?: string ): string
		telegram_token_commit( next?: any ): any
		Telegram_token( ): $mol_password
		Telegram_token_label( ): $mol_labeler
		telegram_chat_id_draft( next?: string ): string
		telegram_chat_id_commit( next?: any ): any
		Telegram_chat_id( ): $mol_string
		Telegram_chat_id_label( ): $mol_labeler
		Telegram_notifications( ): $mol_view
		max_token_draft( next?: string ): string
		max_token_commit( next?: any ): any
		Max_token( ): $mol_password
		Max_token_label( ): $mol_labeler
		max_chat_id_draft( next?: string ): string
		max_chat_id_commit( next?: any ): any
		Max_chat_id( ): $mol_string
		Max_chat_id_label( ): $mol_labeler
		Max_notifications( ): $mol_view
		scope( ): string
		sub( ): ReturnType< $shm_dashboard_admin_settings['settings_rows'] >
		Defaults( ): $mol_view
		Notifications( ): $mol_view
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map